/**
 * Detects if modifier keys (Cmd/Ctrl) are pressed during a mouse event
 */
export const hasModifierKeys = (event: React.MouseEvent): boolean => {
  return event.metaKey || event.ctrlKey;
};

export const openInNewTab = (route: string): void => {
  const baseUrl = window.location.origin;
  const fullUrl = route.startsWith('/') ? `${baseUrl}${route}` : `${baseUrl}/${route}`;

  // Use 'noopener,noreferrer' for security and performance:
  // - 'noopener': Prevents the new tab from accessing window.opener, protecting against
  //   malicious scripts that could redirect the original tab
  // - 'noreferrer': Blocks referrer headers for privacy and prevents information leakage
  // - Both flags enable process isolation for better performance and browser stability
  window.open(fullUrl, '_blank', 'noopener,noreferrer');
};

export const handleNavigationWithModifiers = (
  event: React.MouseEvent,
  route: string,
  normalNavigate: () => void,
): void => {
  const hasModifiers = hasModifierKeys(event);

  if (hasModifiers) {
    event.preventDefault();
    event.stopPropagation();
    openInNewTab(route);
  } else {
    normalNavigate();
  }
};
